// 城市房产 加载数据样式
const state = {
    CsfcLoading: false
}
const getters = {
    CsfcLoading: (state) => state.CsfcLoading
}
const mutations = {
    showCSFCloader: state => state.CsfcLoading = true,
    hideCSFCloader: state => state.CsfcLoading = false
}
const actions = {
    showCSFCloader: ({commit}) => {
        commit('showCSFCloader');
    },
    hideCSFCloader: ({commit}) => {
        commit('hideCSFCloader');
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/CSFCloading.js